import React from 'react';
import aboutimage from "../images/2.jpg"

const fpo = () => {
  return (
    <>
      <section className="about-section inner-page">
        <div className="container">
        <div className="row">
        <div className="col-md-6">
          <h1>Fpo</h1>
          <p>
            Welcome to our company! We are dedicated to providing top-quality services and solutions to our customers.
            Our team of experts works diligently to ensure client satisfaction and deliver exceptional results.
          </p>
          <p>
            Our mission is to innovate and inspire. With years of experience in the industry, we are committed to
            driving success for our clients by utilizing the latest technologies and strategies.
          </p>
      </div>

          <div className="col-md-6">
            <img src={aboutimage} />
            </div>


        </div>
        </div>
      </section>
    </>
  );
};

export default fpo;
